import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlimpsesComponent } from 'src/app/view/glimpses/glimpses.component';
import { MagazineComponent } from 'src/app/view/glimpses/magazine/magazine.component';
import { ProgramComponent } from 'src/app/view/glimpses/program/program.component';
import { RouterModule, Routes } from '@angular/router';


const route:Routes=[
  {path:'',component:GlimpsesComponent,children:[
    {path:'program',component:ProgramComponent},
    {path:'magazine',component:MagazineComponent}
  ]}
]
@NgModule({
  declarations: [
    GlimpsesComponent,
    ProgramComponent,
    MagazineComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(route)
  ]
})
export class GlimpsesModule { }
